'use strict';
(function(angular) {
  /* Directives */

  var blurFocusDirective = function() {
    return {
      restrict: 'E',
      require: '?ngModel',
      link: function(scope, elm, attr, ctrl) {
        if (!ctrl) {
          return;
        }

        elm.on('focus', function() {
          elm.addClass('ng-hasfocus');

          scope.$apply(function() {
            ctrl.hasFocus = true;
          });
        });

        elm.on('blur', function() {
          elm.removeClass('ng-hasfocus');
          elm.addClass('ng-hasvisited');

          scope.$apply(function() {
            ctrl.hasFocus = false;
            ctrl.hasVisited = true;
          });
        });

        elm.closest('form').on('submit', function() {
          elm.addClass('ng-hasvisited');

          scope.$apply(function() {
            ctrl.hasFocus = false;
            ctrl.hasVisited = true;
          });
        });
      }
    };
  };

  angular.module('activationApp.directives', [])
    .directive('input', blurFocusDirective)
    .directive('input', blurFocusDirective)
    .directive('appVersion', ['version',
      function(version) {
        return function(scope, elm) {
          elm.text(version);
        };
      }
    ])
    .directive('ngMatch', ['$parse',
      function($parse) {
        function link(scope, elem, attrs, ctrl) {
          if (!ctrl) return;
          if (!attrs['ngMatch']) return;

          var firstPassword = $parse(attrs['ngMatch']);

          var validator = function(value) {
            var temp = firstPassword(scope),
              v = value === temp;
            ctrl.$setValidity('match', v);
            return value;
          };
          ctrl.$parsers.unshift(validator);
          ctrl.$formatters.push(validator);
          attrs.$observe('ngMatch', function() {
            validator(ctrl.$viewValue);
          });
        }

        var directive = {
          link: link,
          restrict: 'A',
          require: '?ngModel'
        };
        return directive;
      }
    ]);
})(angular);

